import api from './api';

const operationsService = {
  async getQueuesSummary() {
    return api.get('/api/operations/queues/summary');
  },
  async updateQueueSettings(queueId, settings) {
    return api.request(`/api/operations/queues/${queueId}/settings`, {
      method: 'PATCH',
      body: settings
    });
  },
  async getOperatorsSummary() {
    return api.get('/api/operations/operators/summary');
  },
  async setMyPresence(status) {
    return api.request('/api/operations/operators/me/presence', {
      method: 'PATCH',
      body: { status }
    });
  },
  async listPauseReasons() {
    return api.get('/api/operations/operators/pause-reasons');
  },
  async getMyPresence() {
    return api.get('/api/operations/operators/me/presence');
  },
  async getMyCurrentPause() {
    return api.get('/api/operations/operators/me/pause/current');
  },
  async startMyPause(pauseReasonId, note = null) {
    return api.post('/api/operations/operators/me/pause', { pauseReasonId, note });
  },
  async endMyPause() {
    return api.post('/api/operations/operators/me/pause/end', {});
  },
  async getOmniHealth() {
    return api.get('/api/operations/omni/health');
  },
  async listSmsAndroidGateways() {
    return api.get('/api/operations/sms-android/gateways');
  },
  async patchSmsAndroidGateway(id, patch) {
    return api.request(`/api/operations/sms-android/gateways/${id}`, {
      method: 'PATCH',
      body: patch
    });
  },
  async startSmsAndroidPairing() {
    return api.post('/api/operations/sms-android/pairing/start', {});
  }
};

export default operationsService;
